<template>
    <div>
        <a class="tour-button button is-primary"  v-if="!active" @click="start"><!--<i class="fa fa-wpexplorer fa-3x"></i>--><span class="tour-button-text has-text-centered">CLICK ME</span></a>
        <div class="tour-overlay" :class="{ 'active' : active }" @click="skip" v-on:keyup.esc="skip">
        </div>
        <div class="tour-tooltip" role="dialog" :style="{top: toolTipPosition.top + 'px', left: toolTipPosition.left + 'px'}" v-if="active" v-on:keyup.esc="skip">
            <div class="tour-step-number">{{currentStep + 1}}</div>
            <div class="tour-tooltiptext" v-html="step.text"></div>
            <div class="tour-bullets" v-if="steps.length > 0">
                <ul role="tablist">
                    <li role="presentation" v-for="(step, index) in steps">
                        <a role="button" :class="{ 'active' : index == currentStep}" :tabindex="index" @click="changeStep(index)">&nbsp;</a>
                    </li>
                </ul>
            </div>
            <div class="tour-arrow top">

            </div>
            <div class="tour-tooltipbuttons">
                <button class="button is-small" role="button" tabindex="0" v-if="currentStep == (steps.length - 1)" @click="done">{{btnDoneText}}</button>
                <button class="button is-small" role="button" tabindex="0" v-if="(step.options && step.options.nextPage)" @click="nextPage">{{btnNextPageText}}</button>
                <button class="button is-small" role="button" tabindex="0"  v-if="currentStep < (steps.length - 1)" @click="skip">{{btnSkipText}}</button>
                <button role="button" tabindex="0" class="button is-small" :disabled="(step.options && step.options.btnBack === false) || currentStep == 0" @click="prevStep">{{btnPreviousText}}</button>
                <button role="button" tabindex="0" class="button is-small" :disabled="(step.options && step.options.btnNext === false) || currentStep == (steps.length - 1)" @click="nextStep">{{btnNextText}}</button>
            </div>
        </div>
    </div>


</template>
<script>

    import _ from 'lodash'

    export default {
        name: 'VueTour',
        components: {},
        props : {
            active: {
                required: false,
                type: Boolean,
                default: false
            },
            steps: {
                required: true,
                type: Array
            },
            btnSkipText: {
                required: false,
                default: "Skip"
            },
            btnNextText: {
                required: false,
                default: "Next →"
            },
            btnPreviousText: {
                required: false,
                default: "← Back"
            }

        },
        data() {
            return {
                loading: false,
                saving: false,
                direction : 'up',
                currentStep: -1,
                previousStep: -1,
                previousElement: {
                    lastZIndex: -1,
                    lastPosition: "inherit",
                    lastBackground: "transparent",
                },
                toolTipPosition: {
                    left: 0,
                    top: 0
                },
                lastZIndex: -1,
                lastPosition: "inherit",
                lastBackground: "transparent",
            }
        },
        created(){
            let support = {};
            let el = document.documentElement;
            let self = this;
            window.addEventListener("DOMContentLoaded", function () {
                if (support.DOMSubtreeModified) { // for FF 3+, Chrome
                    el.addEventListener('DOMSubtreeModified', self.calculatePosition, false);
                } else { // for FF 2, Safari, Opera 9.6+
                    el.addEventListener('DOMNodeInserted', self.calculatePosition, false);
                    el.addEventListener('DOMNodeRemoved', self.calculatePosition, false);
                }
            }, false);

            window.addEventListener("scroll", self.calculatePosition, false);
            window.addEventListener("resize", self.calculatePosition, false);
        },
        mounted(){

        },
        methods: {

            skip(){
                this.resetElement();
                this.$emit('onSkip', {});
            },
            start(){
                if(!this.active) {
                    this.$emit('onStart', {});
                }
            },
            nextPage(){
                let goToNextPage = this.step && this.step.options && this.step.options.nextPage;
                let nextPage = goToNextPage ? this.step.options.nextPage : '';
                this.skip();
                this.$emit('onNextPage', nextPage);
            },

            done(){
                this.skip();
                this.$emit('onDone', {});
            },
            nextStep(){
                this.previousStep = this.currentStep;
                this.currentStep += 1;
                this.direction = 'up';

                this.$emit('onNextStep', this.currentStep);
            },
            prevStep(){
                this.previousStep = this.currentStep;
                this.currentStep -= 1;
                this.direction = 'down';

                this.$emit('onPreviousStep', this.currentStep);
            },
            loadStep(){

                let element = this.getElement();
                if(element){
                    if(this.previousStep != -1){
                        let prevElement = this.getPreviousElement();
                        if(prevElement){
                            this.unhighlightElement(prevElement);
                        }
                    }

                    this.highlightElement(element);
                    this.calculatePosition(element);
                    this.previousElement = element;
                    let self = this;
                    setTimeout(function(){
                        self.$scrollTo(element);
                    }, 400);

                }
                else{
                    if(this.previousElement) {
                        this.unhighlightElement(this.previousElement);
                    }
                    if(this.direction == 'up'){
                        this.nextStep();
                    }else{
                        this.prevStep();
                    }
                }
            },

            getScreenCordinates(obj) {
                var p = {};
                p.x = obj.offsetLeft;
                p.y = obj.offsetTop;
                while (obj.offsetParent) {
                    p.x = p.x + obj.offsetParent.offsetLeft;
                    p.y = p.y + obj.offsetParent.offsetTop;
                    if (obj == document.getElementsByTagName("body")[0]) {
                        break;
                    }
                    else {
                        obj = obj.offsetParent;
                    }
                }
                return p;
            },

            calculatePosition(){
                if(this.active) {
                    let element = this.getElement();

                    if (element) {
                        var p = this.getScreenCordinates(element)//element.getBoundingClientRect();
                        this.toolTipPosition.top = p.y + element.clientHeight + 14;
                        this.toolTipPosition.left = p.x;
                        //console.log(rect.top, rect.right, rect.bottom, rect.left);
                    }
                }
            },

            resetElement(){
                //console.log('resetElement' + this.currentStep);

                if(this.currentStep != -1){
                    let element = this.getElement();
                    //console.log(element);
                    if(element){
                        this.unhighlightElement(element);
                    }
                }
                this.currentStep =-1;
            },

            resetComponent(){
                this.direction = 'up';
                this.currentStep = -1;
                this.previousStep = -1;
                this.previousElement = {
                    'lastZIndex' : -1,
                    'lastPosition' : "inherit",
                    'lastBackground' : "transparent"
                };
                this.toolTipPosition = {
                    left: 0,
                    top: 0
                };
                this.lastZIndex = -1;
                this.lastPosition = "inherit";
                this.lastBackground = "transparent";
            },

            unhighlightElement(element){
                element.style.zIndex = this.lastZIndex != 999999 ? this.lastZIndex : 1;
                element.style.position = this.lastPosition;
                element.style.background = this.lastBackground;
                element.style.borderRadius = this.lastBorderRadius;
            },

            highlightElement(element){
                //console.log('highlightElement');
                //console.log(element);
                this.lastZIndex = element.style.zIndex;
                this.lastPosition = element.style.position;
                this.lastBackground = element.style.background;
                this.lastBorderRadius = element.style.borderRadius;

                element.style.zIndex = 999;
                element.style.position = "relative";
                element.style.background = "white";
                element.style.borderRadius = "5px";
                //element.style.border = "2px solid rgb(0, 209, 178)";
            },

            getElement(){
                //console.log(document.querySelectorAll(this.step.element));
                if(this.step) {
                    return document.querySelector(this.step.element);
                }
                return null;
            },
            getPreviousElement(){
                return document.querySelector(this.steps[this.previousStep].element);
            },
            changeStep(index){
                this.previousStep = this.currentStep;
                this.currentStep = index;
                this.$emit('onChangeStep', index);
            }
        },
        watch: {
            active: function(val){
                if(val && this.currentStep ==-1){
                    this.resetComponent();
                }
                if(val){
                    this.currentStep = 0;
                }
                else{
                    this.$emit('onSkip', {});
                }
            },
            currentStep: function(val){
                if(val!=-1) {
                    this.loadStep();
                }
            }
        },
        computed: {
            step : function () {
                return this.steps[this.currentStep]
            },
            btnDoneText : function () {
                if(this.step && this.step.options && this.step.options.btnDoneText){
                    return this.step.options.btnDoneText;
                }else{
                    return 'Done';
                }
            },
            btnNextPageText : function () {
                if(this.step && this.step.options && this.step.options.nextPageText){
                    return this.step.options.nextPageText;
                }else{
                    return 'Next Page';
                }
            },

        }

    }
</script>

<style lang="css" scoped>
    .tour-tooltiptext{
        text-align: justify;
        padding: 7px;
    }

    .tour-button-text{
        font-size: 0.80rem;
        font-weight: 500;
    }

    .tour-button{
        bottom: 10vh;
        right: 3vw;
        position: fixed;
        z-index: 999;
        border-radius: 50%;
        /*background-color: #00b89c;*/
        width: 60px;
        height: 60px;
        font-weight: 500;
        /*border: solid 2px;*/
        box-shadow:  0 0 10px  rgba(0,0,0,0.6);
        -moz-box-shadow: 0 0 10px  rgba(0,0,0,0.6);
        -webkit-box-shadow: 0 0 10px  rgba(0,0,0,0.6);
        -o-box-shadow: 0 0 10px  rgba(0,0,0,0.6);
    }

    .tour-step-number {
        background: #ff3860!important;
        border-radius: 50%;
        width: 25px;
        height: 25px;
        color: white;
        text-align: center;
        position: absolute;
        right: -10px;
        top: -10px;
        border: 3px solid #fff;
    }

    .tour-tooltipbuttons {
        text-align: center;
        white-space: nowrap;
    }

    .tour-tooltipbuttons .button{
        height: 1.25em;
        font-weight: normal !important;
    }

    .tour-arrow {
        border: 8px solid transparent;
        content:'';
        position: absolute;
        display: inherit;
    }
    .tour-arrow.top {
        top: -16px;
        border-bottom-color:white;
    }
    .tour-arrow.top-right {
        top: -16px;
        right: 16px;
        border-bottom-color:white;
    }
    .tour-arrow.top-middle {
        top: -16px;
        left: 50%;
        margin-left: -8px;
        border-bottom-color:white;
    }
    .tour-arrow.right {
        right: -16px;
        top: 16px;
        border-left-color:white;
    }
    .tour-arrow.right-bottom {
        bottom:16px;
        right: -16px;
        border-left-color:white;
    }
    .tour-arrow.bottom {
        bottom: -16px;
        border-top-color:white;
    }
    .tour-arrow.bottom-right {
        bottom: -16px;
        right: 16px;
        border-top-color:white;
    }
    .tour-arrow.bottom-middle {
        bottom: -16px;
        left: 50%;
        margin-left: -8px;
        border-top-color:white;
    }
    .tour-arrow.left {
        left: -16px;
        top: 16px;
        border-right-color:white;
    }
    .tour-arrow.left-bottom {
        left: -16px;
        bottom:16px;
        border-right-color:white;
    }

    .tour-bullets{
        text-align: center;
    }
    .tour-bullets ul {
        box-sizing: content-box;
        clear: both;
        margin: 15px auto 0;
        padding: 0;
        display: inline-block;
    }
    .tour-bullets ul li a.active {
        background: rgb(0, 209, 178); /*#999;*/
    }
    .tour-bullets ul li a:hover {
        background: rgb(0, 209, 178); /*#999;*/
    }

    .tour-bullets ul li a:focus {
        outline: 0;
    }

    .tour-bullets ul li {
        box-sizing: content-box;
        list-style: none;
        float: left;
        margin: 0 2px;
    }
    .tour-bullets ul li a {
        box-sizing: content-box;
        display: block;
        width: 6px;
        height: 6px;
        background: #ccc;
        border-radius: 10px;
        -moz-border-radius: 10px;
        -webkit-border-radius: 10px;
        text-decoration: none;
        cursor: pointer;
    }

    .tour-tooltip{
        box-sizing: content-box;
        position: absolute;
        visibility: visible;
        padding: 10px;
        background-color: white;
        min-width: 200px;
        max-width: 300px;
        border-radius: 3px;
        box-shadow: 0 1px 10px rgba(0,0,0,.4);
        z-index: 998;
        -webkit-transition: opacity 0.1s ease-out;
        -moz-transition: opacity 0.1s ease-out;
        -ms-transition: opacity 0.1s ease-out;
        -o-transition: opacity 0.1s ease-out;
        transition: opacity 0.1s ease-out;
    }

    .tour-overlay{
        position: absolute;
        box-sizing: content-box;
        z-index: 998;
        background-color: #000;
        opacity: 0;
        background: -moz-radial-gradient(center,ellipse farthest-corner,rgba(0,0,0,0.4) 0,rgba(0,0,0,0.9) 100%);
        background: -webkit-gradient(radial,center center,0px,center center,100%,color-stop(0%,rgba(0,0,0,0.4)),color-stop(100%,rgba(0,0,0,0.9)));
        background: -webkit-radial-gradient(center,ellipse farthest-corner,rgba(0,0,0,0.4) 0,rgba(0,0,0,0.9) 100%);
        background: -o-radial-gradient(center,ellipse farthest-corner,rgba(0,0,0,0.4) 0,rgba(0,0,0,0.9) 100%);
        background: -ms-radial-gradient(center,ellipse farthest-corner,rgba(0,0,0,0.4) 0,rgba(0,0,0,0.9) 100%);
        background: radial-gradient(center,ellipse farthest-corner,rgba(0,0,0,0.4) 0,rgba(0,0,0,0.9) 100%);
        filter: "progid:DXImageTransform.Microsoft.gradient(startColorstr='#66000000',endColorstr='#e6000000',GradientType=1)";
        -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=50)";
        filter: alpha(opacity=50);
        -webkit-transition: all 0.3s ease-out;
        -moz-transition: all 0.3s ease-out;
        -ms-transition: all 0.3s ease-out;
        -o-transition: all 0.3s ease-out;
        transition: all 0.3s ease-out;
    }
    .tour-overlay.active{
        top: 0px;
        bottom: 0px;
        left: 0px;
        right: 0px;
        position: fixed;
        opacity: 0.8;
    }

    @media all and (max-width: 768px) {

        .tour-button{
            bottom: 7vh;
            right: 3vw;
        }

    }

</style>



// WEBPACK FOOTER //
// src/components/util/VueTour.vue